import { styled, TextField } from "@mui/material";

const CommonEntryPointBox = styled(TextField)(({ theme }) => ({
	"> .MuiOutlinedInput-root .entryPointBox": {
		width: "100%",
	},
	"&.common-entry-point-box > .MuiOutlinedInput-root:hover > .MuiOutlinedInput-notchedOutline":
		{
			borderColor: theme.palette.grey[400],
		},
	".common-entry-point-box > .MuiOutlinedInput-root:hover > .MuiOutlinedInput-notchedOutline":
		{
			borderColor: `${theme.palette.grey[400]} !important`,
		},
	"&.common-entry-point-box > .MuiOutlinedInput-root:hover .MuiOutlinedInput-root > .MuiOutlinedInput-notchedOutline":
		{
			borderColor: theme.palette.grey[400],
		},
	"&.common-entry-point-box > .MuiOutlinedInput-root:hover .MuiOutlinedInput-root:hover:not(.Mui-focused) > .MuiOutlinedInput-notchedOutline":
		{
			borderColor: theme.palette.grey[800],
		},
	"&.common-entry-point-box > .MuiOutlinedInput-root:hover .Mui-focused > .MuiOutlinedInput-notchedOutline":
		{
			borderColor: theme.palette.info.main,
		},
}));

CommonEntryPointBox.defaultProps = {
	classes: {
		root: "common-entry-point-box",
	},
};

export { CommonEntryPointBox };
